var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFlagCa = function SvgFlagCa(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 48 48"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#Flag_CA_svg__a)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "Flag_CA_svg__b",
    width: 48,
    height: 48,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "#FFCF00",
    rx: 24
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#Flag_CA_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFCF00",
    d: "M0 0h48v48H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C71231",
    d: "M48 38H0v6h48zM48 26H0v6h48zM48 14H0v6h48zM48 4H0v5h48z"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "Flag_CA_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h48v48H0z"
  })))));
};
export default SvgFlagCa;